export const ready = (callback: () => void) => {
  if (document.readyState !== 'loading') {
    window.queueMicrotask(callback)
  } else {
    document.addEventListener('DOMContentLoaded', callback, { once: true })
  }
}
